import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';
import './global-partners.styles.scss';

function NewGlobalPartnersLandingPage({
  page: { MainContent, breadCrumbList },
}) {
  const HeroComponent = React.lazy(() =>
    import('./new-global-partners-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-global-partners-content-component')
  );

  return (
    <div className="global-partners-container">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewGlobalPartnersLandingPage;
